import React, { useState } from 'react';
import { Checkbox } from '@heroui/react';
import { Icon } from '@iconify/react';
import { Typography } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';

const FansTab: React.FC = () => {
  const { t } = useTranslations();

  // State for checkboxes
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

  const handleCheckboxChange = (value: string, isSelected: boolean) => {
    if (isSelected) {
      setSelectedFilters([...selectedFilters, value]);
    } else {
      setSelectedFilters(selectedFilters.filter((filter) => filter !== value));
    }
  };

  const filterOptions = [
    { value: 'all', label: t('campaignsStats.modal.fansTab.filters.allSubscribers') },
    { value: 'paid', label: t('campaignsStats.modal.fansTab.filters.paidSubscription') },
    { value: 'recurring', label: t('campaignsStats.modal.fansTab.filters.recurringSubscription') },
    { value: 'one', label: t('campaignsStats.modal.fansTab.filters.onePurchase') },
    { value: 'two', label: t('campaignsStats.modal.fansTab.filters.twoPurchases') },
    { value: 'five', label: t('campaignsStats.modal.fansTab.filters.fivePurchases') },
    { value: 'purchase500', label: t('campaignsStats.modal.fansTab.filters.purchase500') },
    { value: 'messages', label: t('campaignsStats.modal.fansTab.filters.threeMessages') },
  ];

  return (
    <div className="border-b border-[#e2ebf7] px-4 py-4">
      <div className="flex flex-col gap-4">
        {/* Filter Buttons */}
        <div className="flex items-center gap-4">
          {/* Limit Button */}
          <button className="bg-zinc-100 flex items-center gap-1.5 h-9 px-3 py-1.5 rounded-lg shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]">
            <Icon icon="solar:hourglass-linear" width={20} height={20} className="text-neutral-8" />
            <Typography variant="body2" className="text-zinc-500 text-sm leading-[1.125rem]">
              {t('campaignsStats.modal.fansTab.limit')}
            </Typography>
          </button>

          {/* Grouping Button */}
          <button className="bg-zinc-100 flex items-center gap-1.5 h-9 px-3 py-1.5 rounded-lg shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]">
            <Icon icon="solar:widget-4-linear" width={20} height={20} className="text-neutral-8" />
            <Typography variant="body2" className="text-zinc-500 text-sm leading-[1.125rem]">
              {t('campaignsStats.modal.fansTab.grouping')}:{' '}
              <span className="text-auth-ink">{t('campaignsStats.modal.fansTab.days')}</span>
            </Typography>
          </button>

          {/* Type Button */}
          <button className="bg-zinc-100 flex items-center gap-1.5 h-9 px-3 py-1.5 rounded-lg shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]">
            <Icon icon="solar:widget-2-linear" width={16} height={16} className="text-neutral-8" />
            <Typography variant="body2" className="text-zinc-500 text-sm leading-[1.125rem]">
              {t('campaignsStats.modal.fansTab.type')}
            </Typography>
          </button>
        </div>

        {/* Checkboxes */}
        <div className="flex flex-wrap gap-2">
          {filterOptions.map((option) => (
            <Checkbox
              key={option.value}
              isSelected={selectedFilters.includes(option.value)}
              onValueChange={(isSelected) => handleCheckboxChange(option.value, isSelected)}
              classNames={{
                base: 'm-0 p-0',
                wrapper: 'before:border-2 before:border-zinc-300 rounded-[.45rem]',
                label: 'text-auth-ink text-base leading-5 font-normal',
              }}
            >
              {option.label}
            </Checkbox>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FansTab;
